import * as React from "react";

import { cn } from "utils/cn";

export const Skeleton: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => (
  <div
    data-ui="skeleton"
    aria-hidden="true"
    className={cn(
      "animate-pulse rounded-control bg-surface-muted motion-reduce:animate-none",
      className
    )}
    {...props}
  />
);

export const Kbd: React.FC<React.HTMLAttributes<HTMLElement>> = ({ className, ...props }) => (
  <kbd
    data-ui="kbd"
    className={cn(
      "inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded border border-border bg-surface-muted px-1 font-mono text-[11px] font-medium text-muted-foreground",
      className
    )}
    {...props}
  />
);
